import api from './utilBackoffice';

const controller = 'ExcecaoComissionamento';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Create: dto => api.Axios.Post(url, dto),
  Delete: (id, dto) => api.Axios.DeleteDTO(url, id, dto)
});
